import { render, staticRenderFns } from "./approveCard.vue?vue&type=template&id=171c0e20&"
import script from "./approveCard.vue?vue&type=script&lang=js&"
export * from "./approveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports